export default __webpack_public_path__ + "static/media/Wayne-Danckert-Express-Property-300x300.a41b5413.jpg";